import { Component, OnInit, ViewChild } from '@angular/core';
import { VendedorService } from './services/vendedor.service';
import { Vendedor } from './interfaces/vendedor.interface';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-vendedores',
  templateUrl: './vendedores.component.html',
  providers: [MessageService]
})
export class VendedoresComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  
  dataSource: Vendedor[] = [];
  loading: boolean = true;
  displayDialog: boolean = false;
  selectedVendedor: Vendedor | null = null;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'vendedor', header: 'Clave Entidad' },
    { field: 'nombre', header: 'Nombres' },
    { field: 'tipo', header: 'Tipo' },
    { field: 'telefono', header: 'Telefono' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private vendedorService: VendedorService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.vendedorService.getVendedores().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar datos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos'
        });
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  openCreate(): void {
    this.selectedVendedor = null;
    this.displayDialog = true;
  }

  openUpdate(vendedor: Vendedor): void {
    this.loading = true;
    this.vendedorService.getVendedorDetails(vendedor.vendedor).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          this.selectedVendedor = response.data[0];
          this.displayDialog = true;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los detalles del vendedor'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar detalles:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los detalles del vendedor'
        });
        this.loading = false;
      }
    });
  }

  openDelete(vendedor: Vendedor): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este vendedor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.vendedorService.deleteVendedor(vendedor.vendedor).subscribe({
          next: (response) => {
            console.log('Respuesta del servidor:', response);
            if (response.success && response.data === true) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Vendedor eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el vendedor'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el vendedor'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedVendedor = null;
    this.displayDialog = false;
  }

  onSave(event: { success: boolean; message: string }): void {
    if (event.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }
} 